import { Link } from 'react-router-dom';
import VideoCard from '@/components/base/VideoCard';
import { videos } from '@/mocks/data';

export default function FeaturedVideos() {
  const hotVideos = videos.filter((v) => v.isHot).slice(0, 8);
  const newVideos = videos.filter((v) => !v.isHot).slice(0, 8);

  return (
    <>
      <section className="py-8 md:py-10" data-product-shop>
        <div className="w-full px-4 md:px-6">
          <div className="max-w-6xl mx-auto">
            <div className="flex items-center justify-between mb-6">
              <div>
                <h2 className="text-xl md:text-2xl font-bold text-foreground-900 font-heading">
                  热门推荐
                </h2>
                <p className="text-sm text-foreground-500 mt-1">大家都在看的水果视频精选</p>
              </div>
              <Link
                to="/category/dianshiju"
                className="text-sm text-primary-500 hover:text-primary-600 font-medium flex items-center gap-1 cursor-pointer whitespace-nowrap"
              >
                查看更多 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 md:gap-4">
              {hotVideos.map((video) => (
                <VideoCard key={video.id} {...video} />
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="py-8 md:py-10 bg-background-100" data-product-shop>
        <div className="w-full px-4 md:px-6">
          <div className="max-w-6xl mx-auto">
            <div className="flex items-center justify-between mb-6">
              <div>
                <h2 className="text-xl md:text-2xl font-bold text-foreground-900 font-heading">
                  最新上线
                </h2>
                <p className="text-sm text-foreground-500 mt-1">本周新上线的精彩内容</p>
              </div>
              <Link
                to="/category/dianying"
                className="text-sm text-primary-500 hover:text-primary-600 font-medium flex items-center gap-1 cursor-pointer whitespace-nowrap"
              >
                查看更多 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 md:gap-4">
              {newVideos.map((video) => (
                <VideoCard key={video.id} {...video} />
              ))}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}